<p>debug-setting works!</p>

<h1>Debug Setting</h1>

<p>如有异常，请彻底清除浏览器缓存后，重新登录。</p>

<hr>
<button nz-button nzType="primary" (click)="setDebugRegion(RegionCode.LOCAL)">
  本地开发（LOCAL + Dev Auth）
</button>
<br>
<br>
<button nz-button nzType="primary" nzDanger (click)="setDebugRegion(RegionCode.LOCAL_PROD)">
  本地生产（LOCAL API + Prod Auth）
</button>
<br>
<br>
<button nz-button nzType="primary" nzDanger (click)="disableDebugMode()">关闭 Debug 模式</button>
